import * as XLSX from 'xlsx'

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

function num(value) {
  return Number(value ?? 0)
}

function installmentLabel(m) {
  if (m.is_sanction) return 'Amount Sanctioned'
  if (m.missed) {
    return m.installment_number
      ? `Installment - ${m.installment_number} - Not Processed Yet`
      : 'Missed'
  }
  if (m.is_override) {
    return Number(m.deducted_amount) === 0
      ? `Installment - ${m.installment_number} - Skipped`
      : `Installment - ${m.installment_number} - Custom Amount`
  }
  return `Installment - ${m.installment_number}`
}

// Same report payload as salaryAdvanceAPI.getReport(month, year) - one sheet,
// Section 1 then Section 2 stacked underneath, mirroring the on-screen
// Reports tab layout so the Excel reads the same way.
function buildWorkbook(reportData, month, year) {
  const rows = []

  rows.push(['ISKCON BANGALORE HUBLI CENTRE'])
  rows.push([`SALARY ADVANCE REPORT FOR THE MONTH OF ${MONTH_NAMES[month - 1].toUpperCase()} ${year}`])
  rows.push([])

  rows.push(['Section 1 - Salary Advance Details This Month'])
  rows.push(['Employee', 'Type', 'Advance Month', 'Amount', 'Created By', 'Created Time'])
  reportData.section1.forEach((row) => {
    rows.push([
      row.employee,
      row.type,
      row.advance_month || '',
      num(row.amount),
      row.created_by || '',
      row.created_at ? new Date(row.created_at).toLocaleString() : '',
    ])
  })
  if (reportData.section1.length > 0) {
    rows.push(['', '', 'TOTAL', num(reportData.section1_total), '', ''])
  } else {
    rows.push(['No Normal Advance activity this month'])
  }

  rows.push([])
  rows.push([])
  rows.push(['Section 2 - EMI Breakdown (Full History)'])

  if (reportData.section2.length === 0) {
    rows.push(['No EMI activity'])
  }

  reportData.section2.forEach((block, index) => {
    if (index > 0) rows.push([])
    rows.push([])
    rows.push([
      block.employee,
      `Started: ${MONTH_NAMES[block.started_month - 1]} ${block.started_year}`,
      `Monthly Deduction: ₹${num(block.monthly_deduction)}`,
      `Advance Taken: ₹${num(block.advance_taken)}`,
    ])
    rows.push(['Month', 'Installment Number', 'Deducted Amount', 'Balance Remaining'])
    block.months.forEach((m) => {
      rows.push([
        `${MONTH_NAMES[m.month - 1]} ${m.year}`,
        installmentLabel(m),
        m.is_sanction || m.missed ? '-' : num(m.deducted_amount),
        num(m.balance_after),
      ])
    })
    rows.push(['', '', 'Balance to be paid till now', num(block.balance_remaining)])
  })

  const worksheet = XLSX.utils.aoa_to_sheet(rows)
  worksheet['!cols'] = [{ wch: 28 }, { wch: 30 }, { wch: 22 }, { wch: 20 }, { wch: 22 }]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Salary Advance')

  return workbook
}

// Returned as a Blob (not a direct download) - used by the Salary Statement
// page's "Export All" zip, which needs the raw bytes to bundle alongside the
// Attendance and Salary Statement exports.
export function buildSalaryAdvanceExcelBlob(reportData, month, year) {
  const workbook = buildWorkbook(reportData, month, year)
  const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  return new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
}
